import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { Tabs } from '@mui/material';
import {
  $activeChatTab,
  setActiveChatTab,
  TICKET_CHANNEL_TAB_PARAM_NAME,
  TICKET_CHANNEL_TAB_VALUE_SUPPORT,
} from '../../models/chat-tabs';
import {
  ChatTabsComponentTypes,
  chatTabsTypes,
  ChatTabsTypes,
} from '../../types/chat-tabs';
import * as Styled from './styled';

export const ChatTabs = ({
  mainChatId,
  technicalSupportChatId,
}: ChatTabsComponentTypes) => {
  const { t } = useTranslation();
  const [activeChatTab] = useUnit([$activeChatTab]);
  const location = useLocation();

  const handleChange = (_event: React.SyntheticEvent, newValue: ChatTabsTypes) => {
    setActiveChatTab(newValue);
  };

  useEffect(() => {
    setActiveChatTab(chatTabsTypes.employees);
  }, [mainChatId]);

  const checkIfGotoTechSupportTab = () => {
    const searchParams = new URLSearchParams(location.search);
    const ticket_channel_tab = searchParams.get(TICKET_CHANNEL_TAB_PARAM_NAME);

    if (ticket_channel_tab !== TICKET_CHANNEL_TAB_VALUE_SUPPORT) return;

    setActiveChatTab(chatTabsTypes.technicalSupport);
  };

  useEffect(() => {
    checkIfGotoTechSupportTab();
  }, []);

  return (
    <Tabs value={activeChatTab} onChange={handleChange}>
      <Styled.Tab label={t('ChatWithDeclarant')} value={chatTabsTypes.employees} />
      <Styled.Tab label={t('InternalUK')} value={chatTabsTypes.applicant} />

      {technicalSupportChatId && (
        <Styled.Tab
          label={`${t('TechnicalSupport')} Ujin`}
          value={chatTabsTypes.technicalSupport}
        />
      )}
    </Tabs>
  );
};
